import React from 'react';
import { Copy, Gift, Percent } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { couponSummary } from './couponText';

const copy = (code) => { navigator.clipboard?.writeText(code); toast.success('Code copied to clipboard'); };

const CouponRow = ({ c, onToggle }) => {
  const Icon = c.type === 'percent' ? Percent : Gift;
  return (
    <div className={`flex items-center justify-between gap-3 p-4 rounded-lg border transition-colors ${c.is_active ? 'bg-white border-slate-200' : 'bg-slate-50 border-slate-100'}`} data-testid={`coupon-row-${c.code}`}>
      <div className="flex items-start gap-3 min-w-0">
        <span className={`mt-0.5 p-1.5 rounded-md shrink-0 ${c.type === 'percent' ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}`}><Icon className="w-4 h-4" /></span>
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <code className="font-mono font-bold text-[#00247D] break-all">{c.code}</code>
            <button type="button" onClick={() => copy(c.code)} className="text-slate-400 hover:text-slate-600" aria-label="Copy code" data-testid={`coupon-copy-${c.code}`}><Copy className="w-4 h-4" /></button>
          </div>
          <p className="text-sm text-slate-500" data-testid={`coupon-summary-${c.code}`}>{couponSummary(c)} · {c.uses_count}/{c.max_uses} used</p>
        </div>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <span className={`hidden sm:inline px-2 py-1 rounded text-xs font-medium ${c.is_active ? 'bg-green-100 text-green-700' : 'bg-slate-200 text-slate-600'}`}>{c.is_active ? 'Active' : 'Inactive'}</span>
        <Switch checked={c.is_active} onCheckedChange={() => onToggle(c.coupon_id, c.is_active)} data-testid={`coupon-toggle-${c.code}`} />
      </div>
    </div>
  );
};

export const CouponList = ({ coupons, onToggle }) => (
  <Card className="lg:col-span-2 border-slate-200">
    <CardHeader><CardTitle className="text-lg">All Coupons</CardTitle></CardHeader>
    <CardContent>
      <div className="space-y-3" data-testid="coupon-list">
        {coupons.length === 0
          ? <p className="text-slate-500 text-center py-8">No coupons created yet</p>
          : coupons.map((c) => <CouponRow key={c.coupon_id} c={c} onToggle={onToggle} />)}
      </div>
    </CardContent>
  </Card>
);
